import React from 'react';

export const NotFoundPublic = React.lazy(() => import('../pages/NotFound'));
export const LoginPublic = React.lazy(() => import('../pages/Login'));
export const HomePublic = React.lazy(() => import('../pages/Home'));



export const HomePrivate = React.lazy(() => import('../pages/private/Home'));
export const QuestionPrivate = React.lazy(() => import('../pages/private/Question'));
